import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	dialogPaper: {
		paddingBottom: props => (props.title ? 0 : theme.spacing(2))
	},
	title: {
		padding: theme.spacing(1),
		paddingLeft: theme.spacing(3),
		paddingBottom: 0
	},
	content: {
		paddingTop: 0,
		paddingBottom: 0
	}
}));
